import { objectSelector } from 'theme/utils';

const $CC = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/cargoCompanies`);

class CargoCompanies {
  constructor({ results }) {
    this.results = results;
  }
}

class Company {
  constructor({ id, name, shippingCompany, isActive, erp_code }) {
    this.id = id;
    this.name = name;
    this.shippingCompany = shippingCompany;
    this.isActive = isActive;
    this.erp_code = erp_code;
  }
}

const companyMapper = (companies) => {
  return companies.map((item) => {
    return new Company({
      id: objectSelector(item, $CC.COMPANY.ID),
      name: objectSelector(item, $CC.COMPANY.NAME),
      shippingCompany: objectSelector(item, $CC.COMPANY.SHIPPING_COMPANY),
      isActive: objectSelector(item, $CC.COMPANY.IS_ACTIVE),
      erp_code: objectSelector(item, $CC.COMPANY.ERP_CODE),
    });
  });
};

export const cargoCompaniesMapper = (data) => {
  return new CargoCompanies({
    results: companyMapper(objectSelector(data, $CC.PATH, [])),
  });
};



// WEBPACK FOOTER //
// ./src/models/cargoCompanies.js